import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { workflowAPI } from '../lib/api';
import Dashboard from './Dashboard';
import { useWorkflowData } from '../components/home/useWorkflowData';
import { FounderHome } from '../components/home/FounderHome';
import { NayanHome } from '../components/home/NayanHome';
import { NiveditHome } from '../components/home/NiveditHome';
import { UtkarshHome } from '../components/home/UtkarshHome';

const Skeleton = () => (
  <div className="space-y-6 animate-pulse" data-testid="home-loading">
    <div className="h-40 rounded-3xl bg-[#F0EAE1]" />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <div className="h-72 rounded-3xl bg-[#F0EAE1]" />
      <div className="h-72 rounded-3xl bg-[#F0EAE1]" />
    </div>
  </div>
);

const TeamHome = ({ user, roles }) => {
  const data = useWorkflowData();
  if (data.loading) return <Skeleton />;
  if (roles.includes('founder')) return <FounderHome data={data} user={user} />;
  return (
    <div className="space-y-12">
      {roles.includes('submitter') && <NayanHome data={data} user={user} />}
      {roles.includes('creator') && <NiveditHome data={data} user={user} />}
      {roles.includes('distributor') && <UtkarshHome data={data} user={user} />}
    </div>
  );
};

export default function Home() {
  const { user } = useAuth();
  const [roles, setRoles] = useState(null);
  useEffect(() => {
    workflowAPI.me().then((r) => setRoles(r.data.roles || [])).catch(() => setRoles([]));
  }, []);
  if (roles === null) return <Skeleton />;
  if (!roles.length) return <Dashboard />;
  return <TeamHome user={user} roles={roles} />;
}
